import { salesPdfApi } from "../../api";

const SalePdfService = {
  /**
   * 📄 Previsualiza o descarga un documento PDF de venta.
   * GET /api/pdf/sales/{id}
   *
   * Devuelve tanto el blob como el nombre real del archivo (si viene en el header).
   */
  view: async (
    saleId: number
  ): Promise<{ blob: Blob; fileName: string | null }> => {
    const response = await salesPdfApi.fetchBlob(`/${saleId}`);

    // 🧠 Si tu fetchBlob ya fue mejorado, aquí ya tendrás fileName disponible
    return {
      blob: response.data,
      fileName: response.fileName || null,
    };
  },
};

export default SalePdfService;
